import React from "react";
import bitcodeLogo from "../assets/Logo/bitcode_icon.webp";


// export default function FallbackLoader() {
//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
//       role="status"
//       aria-live="polite">
//       <div className="flex flex-col items-center gap-4">
//         {/* Spinner */}
//         <div className="relative w-16 h-16">
//           <div className="absolute inset-0 rounded-full border-4 border-white/20"></div>
//           <div className="absolute inset-0 rounded-full border-4 border-t-[#c31212] border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>
//         </div>

//         {/* Loading text */}
//         <p className="text-white font-semibold tracking-wide text-lg">
//           Loading
//           <span className="inline-flex w-[1.5em] text-left">
//             <span className="animate-dot1 opacity-0">.</span>
//             <span className="animate-dot2 opacity-0">.</span>
//             <span className="animate-dot3 opacity-0">.</span>
//           </span>
//         </p>
//       </div>

//       {/* Dot animations */}
//       <style>
//         {`
//           @keyframes dot {
//             0%   { opacity: 0; }
//             50%  { opacity: 1; }
//             100% { opacity: 1; }
//           }

//           .animate-dot1 {
//             animation: dot 1.4s infinite;
//           }

//           .animate-dot2 {
//             animation: dot 1.4s infinite;
//             animation-delay: 0.4s;
//           }

//           .animate-dot3 {
//             animation: dot 1.4s infinite;
//             animation-delay: 0.6s;
//           }
//         `}
//       </style>
//     </div>
//   );
// }

export default function FallbackLoader() {
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden bg-transparent backdrop-blur-md"
      role="status"
      aria-live="polite"
      aria-busy="true">
      <div className="relative z-10 w-[min(92vw,360px)] px-6 py-4">
        <div className="relative mx-auto mb-6 flex h-28 w-28 items-center justify-center">
          <span
            aria-hidden="true"
            className="bc-loader-ring bc-loader-ring-outer"></span>
          <span
            aria-hidden="true"
            className="bc-loader-ring bc-loader-ring-inner"></span>

          <div className="bc-loader-logo-shell relative z-10 flex h-16 w-16 items-center justify-center rounded-full bg-white/95">
            <img
              src={bitcodeLogo}
              alt="Bitcode logo"
              className="bc-loader-logo h-10 w-10 object-contain"
            />
          </div>
        </div>

        {/* <p className="text-center text-lg font-semibold tracking-wide text-[#cb1a1a]">
          Preparing Bitcode Experience
        </p>
        <p className="mt-1 text-center text-sm text-[#cb1a1a]/80">
          Setting things up for you
        </p> */}

        <div className="mt-6 h-1.5 overflow-hidden rounded-full bg-white/15">
          <span
            aria-hidden="true"
            className="bc-loader-progress block h-full w-[40%] rounded-full bg-gradient-to-r from-[#cb1a1a] via-white to-[#cb1a1a]"></span>
        </div>

        <p className="mt-4 text-center text-sm font-medium text-[#cb1a1a]">
          Loading
          <span className="inline-flex w-[1.5em] text-left">
            <span className="bc-loader-dot bc-loader-dot-1">.</span>
            <span className="bc-loader-dot bc-loader-dot-2">.</span>
            <span className="bc-loader-dot bc-loader-dot-3">.</span>
          </span>
        </p>
      </div>

      <style>
        {`
          @keyframes bcLoaderSpin {
            to {
              transform: rotate(360deg);
            }
          }

          @keyframes bcLoaderSpinReverse {
            to {
              transform: rotate(-360deg);
            }
          }

          @keyframes bcLoaderFloat {
            0%,
            100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-6px);
            }
          }

          @keyframes bcLoaderGlow {
            0%,
            100% {
              box-shadow: 0 0 0 0 rgba(203, 26, 26, 0.25), 0 0 35px rgba(203, 26, 26, 0.35);
            }
            50% {
              box-shadow: 0 0 0 12px rgba(203, 26, 26, 0), 0 0 55px rgba(203, 26, 26, 0.5);
            }
          }

          @keyframes bcLoaderProgress {
            0% {
              transform: translateX(-120%);
            }
            100% {
              transform: translateX(260%);
            }
          }

          @keyframes bcLoaderDot {
            0%,
            20%,
            100% {
              opacity: 0.2;
              transform: translateY(0);
            }
            50% {
              opacity: 1;
              transform: translateY(-2px);
            }
          }

          .bc-loader-ring {
            position: absolute;
            border-radius: 9999px;
          }

          .bc-loader-ring-outer {
            inset: 0;
            border: 1.5px solid rgba(255, 255, 255, 0.35);
            animation: bcLoaderSpin 4s linear infinite;
          }

          .bc-loader-ring-inner {
            inset: 8px;
            border: 2px dashed rgba(203, 26, 26, 0.85);
            animation: bcLoaderSpinReverse 2.8s linear infinite;
          }

          .bc-loader-logo-shell {
            animation: bcLoaderGlow 2s ease-in-out infinite;
          }

          .bc-loader-logo {
            animation: bcLoaderFloat 2.1s ease-in-out infinite;
          }

          .bc-loader-progress {
            animation: bcLoaderProgress 1.5s ease-in-out infinite;
          }

          .bc-loader-dot {
            animation: bcLoaderDot 1.4s infinite;
          }

          .bc-loader-dot-2 {
            animation-delay: 0.2s;
          }

          .bc-loader-dot-3 {
            animation-delay: 0.4s;
          }

        `}
      </style>
    </div>
  );
}
